export const paragraphToBr = (str: string) => {
    if (str === "\n") return "";
    return str.split("\n").join("<br />")
};
export const brToParagraph = (str: string) => {
    if (str === "<br />") return "";
    return str.split("<br />").join("\n");
}